@if (timeZoneId) {
  <h5>Time Zone</h5>
  <div class="extension-detail-item">{{ timeZoneId }}</div>
}

